import { Link } from 'react-router-dom';
import QuoteWizard from './components/QuoteWizard';

export default function SolarQuotePage() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Minimal header */}
      <header
        className="px-4 md:px-8 h-16 flex items-center justify-between flex-shrink-0 sticky top-0 z-40 border-b"
        style={{ background: '#145A32', borderColor: 'rgba(0,0,0,0.2)' }}
      >
        <Link to="/" className="flex items-center gap-2">
          <img
            src="https://static.readdy.ai/image/4a891bf01ca77aa59d4e684a3f5f885b/ee62e899e0ea98d48397a860148ed960.png"
            alt="Renewables Made Easy"
            className="h-10 w-auto object-contain"
          />
        </Link>
        <div className="flex items-center gap-4">
          <a
            href="tel:03300101234"
            className="hidden sm:flex items-center gap-2 font-bold text-sm transition-opacity hover:opacity-80 cursor-pointer whitespace-nowrap"
            style={{ color: '#ffffff' }}
          >
            <div
              className="w-7 h-7 flex items-center justify-center rounded-full"
              style={{ background: 'rgba(255,255,255,0.15)' }}
            >
              <i className="ri-phone-line text-sm" style={{ color: '#7AC943' }} />
            </div>
            0330 010 1234
          </a>
          <div
            className="flex items-center gap-1.5 text-xs font-bold px-3 py-1.5 rounded-full"
            style={{ background: 'rgba(122,201,67,0.2)', color: '#7AC943' }}
          >
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-shield-check-line text-xs" />
            </div>
            Free · No Obligation
          </div>
        </div>
      </header>

      {/* Wizard */}
      <main className="flex-1">
        <QuoteWizard />
      </main>
    </div>
  );
}
